module.exports = __webpack_public_path__ + "static/media/butterfly_staxx_2.netent.2198118e.jpeg";